<section class="events" id="eventos" aria-labelledby="events-title">
  <div class="events__inner">
    <header class="events__header">
      <h2 id="events-title" class="events__title">Coberturas recentes</h2>
      <p class="events__subtitle">Explore os registros dos eventos cobertos pela Loba Cria.</p>
    </header>

    <div
      #viewport
      class="events__viewport"
      (pointerdown)="onCarouselPointerDown($event)"
      (pointermove)="onCarouselPointerMove($event)"
      (pointerup)="onCarouselPointerUp($event)"
      (pointercancel)="onCarouselPointerCancel($event)"
    >
      <div
        #track
        class="events__track"
        role="list"
        [class.events__track--marquee]="mobileCarousel()"
        [style]="transformStyle()"
      >
        @for (event of loopItems(); track event.trackKey) {
          <article class="event-card" role="listitem">
            <div class="event-card__surface">
              <div class="event-card__thumb">
                <img [src]="event.imageUrl" [alt]="event.name" loading="lazy" />
                <div class="event-card__thumb-overlay"></div>
              </div>
              <div class="event-card__body">
                <span class="event-card__category">{{ event.category }}</span>
                <h3 class="event-card__name">{{ event.name }}</h3>
                <app-pill-button
                  label="Acessar"
                  variant="event-access"
                  [href]="event.coverageUrl"
                  [external]="true"
                />
              </div>
            </div>
          </article>
        }
      </div>
    </div>
  </div>
</section>
